import { ReactNode, forwardRef } from 'react';
import { Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import { joinPath } from 'utils/pathHelpers';

interface NavLinkWithChipProps {
  to: string;
  /** When linking to point-o-gms, use this path instead of `to` (e.g. /gms-dashboard) */
  externalTo?: string;
  children: ReactNode;
  [propName: string]: unknown;
}

// Normally a forwardRef component wouldn't be wrapped by a function,
// but in this case a boolean needed to be passed in.
export const NavLinkWithChip = (
  isFeatureEnabled: boolean,
  pointOGmsBaseUrl?: string
) =>
  forwardRef<unknown, NavLinkWithChipProps>(
    (
      { to, externalTo, children, ...props }: NavLinkWithChipProps,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _ref
    ) => (
      <div className="AppHeader-LinkContainer">
        {pointOGmsBaseUrl ? (
          <a href={joinPath(pointOGmsBaseUrl, externalTo ?? to)} {...props}>
            {children}
          </a>
        ) : (
          <Link to={to} {...props}>
            {children}
          </Link>
        )}
        {isFeatureEnabled !== undefined && !isFeatureEnabled && (
          <Chip label="PRO" className="AppHeader-Chip" />
        )}
      </div>
    )
  );
